import * as yup from "yup";


const SurveyQuestionnaireValidationSchema = yup.array().of(yup.object().shape({
    id: yup.number().optional(),
    question_type: yup.string().required("Question type is required."),
    content: yup.string().required("question is required."),
    choices: yup.array().of(yup.object().shape({
      id: yup.number().optional(),
      content: yup.string().required("Option is required."),
      order_number: yup.number().optional()
    })).optional()
  })).required("Question is required");

export default SurveyQuestionnaireValidationSchema;